/**
 * Reverse-geocode lat/lon to a human-readable address (e.g. for patient spotted location).
 * Uses OpenStreetMap Nominatim, same approach as pharmacy portal audit trail.
 */
const geocodeCache = new Map();

export async function reverseGeocode(lat, lon) {
  const numLat = Number(lat);
  const numLon = Number(lon);
  if (!Number.isFinite(numLat) || !Number.isFinite(numLon)) return null;
  const key = `${numLat},${numLon}`;
  if (geocodeCache.has(key)) return geocodeCache.get(key);
  try {
    const res = await fetch(
      `https://nominatim.openstreetmap.org/reverse?format=json&lat=${numLat}&lon=${numLon}`,
      { headers: { "Accept-Language": "en", "User-Agent": "OatRX-DriverApp/1.0" } }
    );
    if (!res.ok) throw new Error("geocode failed");
    const data = await res.json();
    const resolved = data?.display_name || null;
    geocodeCache.set(key, resolved);
    return resolved;
  } catch {
    geocodeCache.set(key, null);
    return null;
  }
}
